import { render } from "./Courses.vue?vue&type=template&id=31e93477&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"

import "./Courses.vue?vue&type=style&index=0&id=31e93477&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e93477"],['__file',"src/views/Courses/Courses.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31e93477"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31e93477', __exports__)) {
    api.reload('31e93477', __exports__)
  }
  
  module.hot.accept("./Courses.vue?vue&type=template&id=31e93477&scoped=true", () => {
    api.rerender('31e93477', render)
  })

}


export default __exports__